import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const mount = document.getElementById('order-app');
let mode = '';
let postalCode = null;

if (mount) {
    mode = window.ORDER_APP_SETTINGS.mode;
    postalCode = localStorage.getItem('postalCode');
}

// remove localstorage
localStorage.removeItem(`vuex-order-${mode}`);

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
        mode: 'business', // 'business' or 'private'
        subscriptionType: null, // TODO: add default values from API
        people: 1,
        earlyInvoice: false,
        appetite: null,
        baskets: {
            monday: [],
            wednesday: [],
        },
        basketPeople: {
            monday: [],
            wednesday: [],
        },
        basketExtra: {
            monday: [],
            wednesday: [],
        },
        intervals: {
            monday: 1, // interval id
            wednesday: 1,
        },
        selectedExtra: {
            category: null,
            item: null,
        },
        editModalVisible: false,
        orderExtraModalVisible: false,
        priceSummaryModalVisible: false,
        priceSummaryOverviewModalVisible: false,
        infoBoxModalVisible: false,
        infoBoxModalContent: '',
        quoteModalVisible: false,
        loadingModalVisible: false,
        loadingModalMessage: '',
        testBasketModalVisible: false,
        privateDeliveryDay: 'monday',
        sameInvoiceAddress: true,
        orderable: {
            earlyDeliveryFee: 5,
            deliveryFee: 8.5,
            product_groups: [],
            intervals: [
                {
                    id: 1,
                    name: 'wöchentlich',
                },
                {
                    id: 2,
                    name: 'alle zwei Wochen',
                },
            ],
            extras: [],
            firstDeliveryDay: null,
        },
        postalCode: postalCode !== 'undefined' ? postalCode : null,
        isValidPostalCode: false,
        order: {
            user: {
                invoice_by_post: true,
                newsletter: true,
            },
            comment: '',
            attention_by: '',
            coupon: null,
            invoice_address: {
                company: '',
                firstname: '',
                lastname: '',
                additional_billing: '',
                additional_shipping: '',
                street: '',
                zip: '',
                city: '',
                email_contact: '',
                phone: '',
                mobile: '',
            },
            delivery_address: {
                company: '',
                firstname: '',
                lastname: '',
                additional_billing: '',
                additional_shipping: '',
                street: '',
                zip: '',
                city: '',
                email_contact: '',
                phone: '',
                mobile: '',
            },
            subscriptions: [],
        },
    },
    plugins: [createPersistedState({
        // use different storages for business & private
        key: `vuex-order-${mode}`,
    })],
    getters,
    mutations,
    actions,
});

export default store;



// WEBPACK FOOTER //
// ./static/js/Order/store/index.js